import { render } from "./SelectModuleV1.vue?vue&type=template&id=23dced5c&scoped=true"
import script from "./SelectModuleV1.vue?vue&type=script&lang=js"
export * from "./SelectModuleV1.vue?vue&type=script&lang=js"

import "@/assets/css/selectModule.sass?vue&type=style&index=0&id=23dced5c&lang=sass&scoped=true"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=23dced5c&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dced5c"]])

export default __exports__